export default __webpack_public_path__ + "static/media/pic3.1a36452f.jpg";